import CustomInput from 'src/components/general/Form'
import styled from 'styled-components'
import Select from 'react-select'
import Calendar from 'src/components/Calendar'
import moment from 'moment'
import FrequencyInput from './FrequencyInput'
import { useCallback } from 'react'
import TimeLockSummary from './TimeLockSummary'

const modeOptions = [
  { value: 'Seconds', label: 'Seconds' },
  { value: 'OnDay', label: 'OnDay' },
  { value: 'LastMonthDay', label: 'LastMonthDay' },
]

const TimeLockEdit = ({ task, handleInputChange }) => {
  const memoizedHandleInputChange = useCallback(
    (field: string, value: string) => handleInputChange(task.id, field, value.toString()),
    [task.id, handleInputChange]
  )

  const handleAllowedAt = useCallback(
    (date: Date | null) => {
      if (!date) return
      const unixTimestamp = moment(date).unix()
      handleInputChange(task.id, 'allowedAt', unixTimestamp.toString())
    },
    [handleInputChange, task.id]
  ) 

  // const allowedAtFormatted = moment(task?.taskConfig?.timeLock?.allowedAt * 1000).format('YYYY-MM-DD HH:mm')
  const allowedAtFormatted = moment.unix(task?.taskConfig?.timeLock?.allowedAt).utc().format('YYYY-MM-DD HH:mm')
  return (
    <div>
      <div className="flex-group">
        <FlexColumn>
          <Flex>
            {/* MODE */}
            <Input
              type="text"
              name="mode"
              label="Mode"
              value={task?.taskConfig?.timeLock?.mode}
              onChange={(e) => memoizedHandleInputChange('mode', e.target.value)}
            />

            <StyledSelect
              classNamePrefix="Select"
              onChange={(selectedOption) => memoizedHandleInputChange('mode', selectedOption.value)}
              options={modeOptions}
              defaultValue={null}
            />
          </Flex>
          <Flex>
            <CustomInput
              type="text"
              name="allowedAt"
              label="Allowed At"
              value={task?.taskConfig?.timeLock?.allowedAt}
              onChange={(e) => memoizedHandleInputChange('allowedAt', e.target.value)}
            />

            <Calendar label={allowedAtFormatted} withHour={true} onChange={handleAllowedAt} /> <UtcLabel>(UTC)</UtcLabel>
          </Flex>
          <Flex>
            <CustomInput
              type="text"
              name="frequency"
              label="Frequency"
              value={task?.taskConfig?.timeLock?.frequency}
              onChange={(e) => memoizedHandleInputChange('frequency', e.target.value)}
            />
            <FrequencyInput
              handleInputChange={memoizedHandleInputChange}
              taskId={task.id}
              timeframe="frequency"
              currentValue={task?.taskConfig?.timeLock?.frequency}
            />
          </Flex>
          <Flex>
            <CustomInput
              type="text"
              name="window"
              label="Window"
              value={task?.taskConfig?.timeLock?.window}
              onChange={(e) => handleInputChange(task.id, 'window', e.target.value)}
            />
            <FrequencyInput
              handleInputChange={memoizedHandleInputChange}
              taskId={task.id}
              timeframe="window"
              currentValue={task?.taskConfig?.timeLock?.window}
            />
          </Flex>
          <TimeLockSummary task={task} />
        </FlexColumn>
      </div>
    </div>
  )
}

export default TimeLockEdit

const Input = styled(CustomInput)``

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;

  /* Align right-side controls with CustomInput (which has margin-bottom: 20px) */
  & > div:not(:first-child) {
    padding-bottom: 20px;
    display: flex;
    align-items: center;
  }
`

const UtcLabel = styled.span`
  color: #888;
  font-size: 13px;
  font-family: 'DMSans';
`

const StyledSelect = styled(Select)`
  min-width: 200px;

  .Select__control {
    background: transparent;
    border: 2px solid #5f5d62;
    border-radius: 10px;
    min-height: 34px;
    height: 34px;
    box-shadow: none;
    cursor: pointer;

    &:hover {
      border-color: #0070f3;
    }
  }

  .Select__value-container {
    padding: 0 10px;
  }

  .Select__single-value {
    color: #fff;
    font-size: 13px;
    font-family: 'DMSans';
  }

  .Select__placeholder {
    color: #888;
    font-size: 13px;
  }

  .Select__indicator-separator {
    display: none;
  }

  .Select__dropdown-indicator {
    color: #5f5d62;
    padding: 0 8px;
  }

  .Select__menu {
    background: #2e2c3e;
    border: 2px solid #5f5d62;
    border-radius: 10px;
    z-index: 10;
  }

  .Select__option {
    color: #fff;
    font-size: 13px;
    cursor: pointer;

    &:hover,
    &.Select__option--is-focused {
      background: rgba(148, 135, 229, 0.2);
    }

    &.Select__option--is-selected {
      background: rgba(148, 135, 229, 0.35);
    }
  }
`
